var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsString, Matches, MaxLength, MinLength } from 'class-validator';
import { countryRegex } from '../../countries.js';
export class AddressValidationRequestDto {
    street;
    zip;
    town;
    countryCode;
    static fromOfficeLocation(officeLocation) {
        const addressValidation = new AddressValidationRequestDto();
        addressValidation.street = officeLocation.street;
        addressValidation.zip = officeLocation.zip;
        addressValidation.town = officeLocation.town;
        addressValidation.countryCode = officeLocation.countryCode;
        return addressValidation;
    }
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AddressValidationRequestDto.prototype, "street", void 0);
__decorate([
    IsString(),
    MinLength(4),
    MaxLength(5),
    Expose(),
    __metadata("design:type", String)
], AddressValidationRequestDto.prototype, "zip", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AddressValidationRequestDto.prototype, "town", void 0);
__decorate([
    IsString(),
    MaxLength(3),
    Expose(),
    Matches(countryRegex),
    __metadata("design:type", String)
], AddressValidationRequestDto.prototype, "countryCode", void 0);
//# sourceMappingURL=address-validation-request.dto.js.map